<template>
    <div class="text-center">
        <h3 class="title-style" @click="$emit('click')">{{ title }}</h3>
    </div>
</template>
<script>
export default {
    props: ['title']
};
</script>
<style lang="scss" scoped>
.title-style {
    text-transform: uppercase;
    font-weight: 700;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.45);
    display: flex;
    justify-content: center;
    align-items: center;
    &::before,
    &::after {
        content: '';
        display: block;
        height: 0.09em;
        min-width: 15vw;
    }

    &::before {
        background: linear-gradient(to right, rgba(240, 240, 240, 0), lightseagreen);
        margin-right: 2vh;
    }

    &::after {
        background: linear-gradient(to left, rgba(240, 240, 240, 0), lightseagreen);
        margin-left: 2vh;
    }
}
@media screen and (max-width: 500px) {
    .title-style {
        font-size: 1.25rem;
    }
}
</style>